// Add this at the very top of your main.js/entry file
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
window.__VUE_OPTIONS_API__ = true;
window.__VUE_PROD_DEVTOOLS__ = false;

import { createApp } from 'vue'
import App from './App.vue'
import { initGA } from '../analytics';
import router from './router/index'
import i18n from '../i18n';
import './assets/styles.css';

// Initialiser Google Analytics
initGA();

const app = createApp(App);
app.use(i18n);
app.use(router);
router.isReady().then(() => {
    app.mount('#app');
    document.dispatchEvent(new Event('render-event'));
});